import { getSitePages } from '@gik/api/legal';
import type { FallbackProps, StaticProps } from '@gik/core/api/BaseAPIConfig';
import { baseFallback, ISRRevalidateTimeout } from '@gik/core/api/BaseAPIConfig';
import { withTitle } from '@gik/core/hocs/withTitle';
import { SitemapPage } from '@gik/core/pages/Sitemap';
import { catchSSRError } from '@gik/core/utils/catchSSRError';
import { measureSSRPerformance } from '@gik/core/utils/measureSSRPerformance';
import React from 'react';
import { SWRConfig } from 'swr';
import Head from '@/components/Head';
import { PageHeadKeys } from '@gik/core/hocs/PageHeadKeys';

export default function SitemapPageComp({ fallback }: FallbackProps<unknown>) {
  return withTitle(
    'Sitemap',
    <SWRConfig value={{ fallback }}>
      <Head>
        <meta name="robots" key={PageHeadKeys.META_ROBOTS} content="index,follow" />
      </Head>
      <SitemapPage />
    </SWRConfig>
  );
}

async function _getStaticProps(): Promise<StaticProps<string[]>> {
  const sitePages = getSitePages();

  const json = await sitePages.json;

  return baseFallback({ [sitePages.key]: json }, undefined, ISRRevalidateTimeout.sitemapSlow);
}

export const getStaticProps = catchSSRError(measureSSRPerformance(_getStaticProps));
